// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1abcc589","239":"754b2453","453":"341f010f","455":"6e8bd518"}[chunkId] + ".chunk.js";
};